export const proveedores = [
	{
		"nombre": "Requisitos Proveedor Ampliación",
		"icono":"DatosContactoUnidad.png",
		"formatos": [
			{
				// "nombre": "Las personas físicas y morales interesadas.",
				// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
				// "html": "./Transparencia/htm/a69_f13_SC.htm"
			}
		],
		 "url" : "/interes/REQUISITOS PROVEEDOR MODIFICACIÓN-junio.pdf"
	},
	{
			"nombre": "Requisitos Proveedor Cambio de Accionistas",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
				 "url" : "/interes/REQUISITOS PROVEEDOR O CONTRATISTA CAMBIO DE ACCIONISTAS-junio.pdf"
		},
		{
			"nombre": "Requisitos Proveedor Inscripción",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/REQUISITOS PROVEEDOR INSCRIPCION-junio.pdf"
		},

			{
			"nombre": "Aviso de Privacidad simplificado",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/Aviso de Privacidad Simplificado.docx"
			},

			{
			"nombre": "Carta bajo protesta de decir verdad socio." ,
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/CARTA BAJO PROTESTA DE DECIR VERDAD SOCIO-junio.docx"
			},

			{
			"nombre": "Carta bajo protesta de decir verdad representante legal." ,
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/CARTA BAJO PROTESTA DE DECIR VERDAD REPRESENTANTE LEGAL-junio.docx"
			},


				{
			"nombre": "Captura de datos.",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/CAPTURA DE DATOS IPPCEH DGN.docx"
			},

			
			{
			"nombre": "Requisitos proveedor canje.",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					// "nombre": "Las personas físicas y morales interesadas.",
					// "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
					// "html": "./Transparencia/htm/a69_f13_SC.htm"
				}
			],
			"url" : "/interes/REQUISITOS PROVEEDOR CANJE-junio.pdf"
			},

			
	
]